import { render, staticRenderFns } from "./AjanlatAdatokB9_V0.vue?vue&type=template&id=775a1084&"
import script from "./AjanlatAdatokB9_V0.vue?vue&type=script&lang=js&"
export * from "./AjanlatAdatokB9_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports